import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { extractMath, Segment } from 'extract-math';
import { FormulaConfigurations } from '../items-canvas/board-items/board-formula-configurations';

@Component({
  selector: 'app-formula',
  templateUrl: './formula.component.html',
  styleUrls: ['./formula.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormulaComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() state!: FormulaConfigurations;
  @Input() static = false;
  @Input() opacity = 1;

  @Output() stateChanged = new EventEmitter<void>();
  @Output() contentSizeChanged = new EventEmitter<{ width: number; height: number }>();

  @ViewChild('formulaContainer') formulaContainer?: ElementRef<HTMLDivElement>;

  readonly segments$ = new BehaviorSubject<Segment[]>([]);

  private resizeObserver?: ResizeObserver;

  ngAfterViewInit() {
    if (this.static) {
      return;
    }

    // Create ResizeObserver to watch for size changes
    this.resizeObserver = new ResizeObserver((entries) => {
      const formulaContainerDiv = this.formulaContainer?.nativeElement;
      if (!formulaContainerDiv) {
        return;
      }
      this.contentSizeChanged.emit({
        width: formulaContainerDiv.clientWidth,
        height: formulaContainerDiv.clientHeight,
      });
    });

    if (this.formulaContainer) {
      this.resizeObserver.observe(this.formulaContainer.nativeElement);
    }
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.state?.currentValue?.equation && !changes.state?.firstChange) {
      return;
    }
    const messageData =
      this.state.equation?.charAt(0) === '>'
        ? this.state.equation.replace('>', '\\>')
        : this.state.equation;
    this.segments$.next(extractMath(messageData));
  }
}
